<template>
    <div>
        <sav-template :title="'Connexion'">
            <template v-if="!isPro">
                <h2 class="text-2xl font-bold">{{ $t('bienvenue.actors.etes_vous_un_particulier_?') }}</h2>
                <div @click="$router.push({name: 'user.register'})" class="mt-3 p-6 bg-white hover:bg-slate-100 duration-200 cursor-pointer shadow border my-rounded flex items-center justify-between">
                    <div>
                        <h3 class="text-xl font-base">{{ $t('bienvenue.actors.je_suis_un_particulier') }}</h3>
                        <p class="font-light text-sm mt-0.5">{{ $t('bienvenue.actors.je_souhaite_saisir_sur_cet_espace_en_tant_que_consommateur') }}</p>
                    </div>
                    <i class="fas fa-chevron-right"></i>
                </div>
                <div @click="isPro = true" class="mt-3 p-6 bg-white hover:bg-slate-100 duration-200 cursor-pointer shadow border my-rounded flex items-center justify-between">
                    <div>
                        <h3 class="text-xl font-base">{{ $t('bienvenue.actors.je_suis_un_professionnel') }}</h3>
                        <p class="font-light text-sm mt-0.5">{{ $t('bienvenue.actors.je_souhaite_saisir_un_dossier_en_tant_que_professionnel') }}</p>
                    </div>
                    <i class="fas fa-chevron-right"></i>
                </div>
            </template>
            <template v-if="isPro">
                <h2 class="text-3xl text-orange-500 font-black">{{ $t('bienvenue.actors.vous_ne_pouvez_pas_saisir_sur_cet_espace') }}</h2>
                <h2 class="text-lg font-light mt-3">{{ $t('bienvenue.actors.en_tant_que_professionnel_vous_devez_saisir_votre_dossier_sur_la_plateforme_prevue_a_cet_effet') }}</h2>
                <div class="mt-6">
                    <a class="text-lg bg-orange-200 hover:bg-orange-300 duration-200 cursor-pointer text-orange-800 px-6 py-2 rounded" href="https://districloud.net">
                        {{ $tt('Utiliser la plateforme') }} <i class="fa-solid fa-arrow-up-right-from-square ml-1"></i>
                    </a>
                </div>
            </template>
        </sav-template>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                isPro: false
            }
        },
        mounted () {
            if (this.$companyTool.confFile().pro_particulier == '0') {
                this.$router.push({name: 'user.register'})
            }
        },
    }
</script>

<style lang="scss" scoped>

</style>


// WEBPACK FOOTER //
// src/companies/default/views/user/ActorsLogin.vue